<template>
  <div id="six">
    <div class="rightContent">
      <div class="tableheader">
        <div style="text-align:right;display: flex;">
          <el-button style="float:left" @click="edit(false)" size="mini" plain>添加预测</el-button>
          <el-input v-model="q" placeholder="请输入期数\日期\标题" size="mini"></el-input>
          <el-button style="margin-left:10px;" @click="getList" size="mini" plain>查找</el-button>
        </div>
      </div>
      <div class="listBlock">
        <el-table :data="lists" style="width: 100%">
          <el-table-column prop="nu_id" label="期数"></el-table-column>
           <el-table-column label="预测内容">
            <template slot-scope="scope">
              <div v-html="scope.row.title"></div>
            </template>
          </el-table-column>
          <el-table-column prop="crt_time" label="添加时间"></el-table-column>
          <el-table-column prop="mark" label="备注"></el-table-column>
          <!-- <el-table-column label="预测状态">
            <template slot-scope="scope">
              <span v-if="scope.row.isright==1">对</span>
              <span v-else-if="scope.row.isright==2">错</span>
              <span v-else>未开</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="edit(scope.row)" size="mini" plain>编辑</el-button>
              <el-button @click="del(scope.row.id)" size="mini" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:10px;text-align:center;">
          <el-pagination
            background
            layout="prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            :page-sizes="[10,20,50,100]"
            :total="datatotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog width="40%" :title="edittitle" :visible.sync="showForm">
      <el-form :model="ycform">
        <el-form-item label="预测期数" :label-width="formLabelWidth">
          <el-input v-model="ycform.nu_id" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="预测内容" :label-width="formLabelWidth" style="height:100px;">
          <quill-editor v-model="ycform.title" ref="myQuillEditor" style="height: 60px;" :options="editorOption">
            <div id="toolbar" slot="toolbar">
              <button class="ql-bold" title="加粗">Bold</button>
              <select class="ql-color" value="color" title="字体颜色"></select>
            </div>
          </quill-editor>
        </el-form-item>
        <!-- <el-form-item label="预测结果" :label-width="formLabelWidth">
          <el-select v-model="ycform.isright" placeholder="预测结果">
            <el-option label="未开" value="0"></el-option>
            <el-option label="对" value="1"></el-option>
            <el-option label="错" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="预测备注" :label-width="formLabelWidth">
          <el-input v-model="ycform.mark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="goSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  name: "six",
  components: {
    quillEditor
  },
  data() {
    return {
      doing: false,
      lists: [],
      formLabelWidth: '120px',
      catelist: '',
      q: '',
      edittitle: '新增预测',
      ycform: {
        nu_id: 0,
        title: '',
        mark: '',
        isright: '0'
      },
      showForm: false,
      datatotal: 0,
      pageNo: 1,
      pageSize: 20,
      editorOption: {
        modules: {
          toolbar: '#toolbar'
        },
        theme: 'snow',
        placeholder: '请输入正文'
      }
    };
  },
  computed: {},
  created() {
    this.resizedwindow();
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNo = val
      this.getList()
    },
    getList() {
      if (this.doing === true) {
        return false;
      }
      let dataLoadIng = this.openFullScreen()
      this.doing = true;
      let _this = this;
      let data = {
        q: this.q,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios
        .post("/kaiSrv/mgr/sixList", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code == 0) {
            _this.lists = response.data.list;
            _this.datatotal = parseInt(response.data.total);
          }
          setTimeout(() => {
            dataLoadIng.close()
          }, 500);
        });
    },
    edit(item) {
      if(item){
        this.ycform = item
        this.edittitle = '修改预测'
      }else{
        this.ycform = {
          nu_id: 0,
          title: '',
          mark: '',
          isright: '0'
        }
        this.edittitle = '新增预测'
      }
      this.showForm =  true
    },
    goSubmit(){
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = this.ycform
      this.axios
        .post("/kaiSrv/mgr/sixSave", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code == 0) {
            _this.getList()
            _this.showForm = false
          }
        });
    },
    del(id){
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {id: id}
      this.axios
        .post("/kaiSrv/mgr/sixDel", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code == 0) {
            _this.getList()
          }
        });
    }
  }
};
</script>
<style  lang="scss">
#six {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-input__inner {
    width: 2.5rem;
  }
  .codeshearch,
  .codeshearch .el-input__inner {
    width: 1.5rem;
  }
  .el-pagination .el-input__inner {
    width: 0.9rem;
  }
  .codeshearch {
    margin-left: 0.05rem;
    margin-right: 0.02rem;
  }
  .avatar-uploader,
  .el-upload,
  .el-upload--text {
    width: 1.22rem;
    height: 1.2rem;
    display: inline-block;
  }
  .avatar-uploader-icon {
    border: 1px solid #ccc;
  }
}
</style>
<style scoped lang="scss">
#six {
  box-sizing: border-box;
  .rightContent {
    width: calc(100% - 0.32rem);
    height: calc(100% - 0.1667rem);
    display: inline-block;
    background-color: #fff;
    margin-left: 0.1667rem;
    margin-top: 0.1667rem;
    border-radius: 0.05rem;
    .tableheader {
      margin: 0.16rem;
    }
    p.title {
      height: 0.4167rem;
      line-height: 0.4167rem;
      font-size: 0.15rem;
      color: #000;
    }
    .btn2,
    .btn3 {
      padding: 0.0667rem 0.0833rem;
      background-color: #409EFF;
      border: 1px solid #409EFF;
    }
    .listBlock {
      margin: 0.08rem;
    }
    .warncolor {
      color: red;
    }
    .btndel {
      margin-left: 0.1rem;
      height: 0.28rem;
      position: relative;
      top: 0.05rem;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 1.22rem;
    height: 0.5rem;
    margin-left: 1rem;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    color: #8c939d;
    width: 1.22rem;
    height: 1.22rem;
    text-align: center;
    line-height: 1.22rem;
    margin-top: 0.08rem;
  }
  .imgblockForLogo {
    width: 1.22rem;
    height: 1.22rem;
    display: inline-block;
    border: 1px solid #ccc;
    margin-top: 0.08rem;
  }
  .avatar {
    width: 1.22rem;
    height: 1.22rem;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/six.vue